import { subscribeChannel, publishChannel } from './channelUtils';

export function sendStatus(status) {
    
    publishChannel('trip-status-analysis-upsert', status);

}

export function sendStatusBatch(statuss) {
    
    publishChannel('trip-status-analysis-batch-upsert', statuss);

}

export function sendDeleteStatus({ date, codigo }) {
    
    publishChannel('trip-status-analysis-delete', { date, codigo });

}

export function listenTripStatusAnalysis(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trip-status-analysis-upsert' &&
            tipo !== 'trip-status-analysis-batch-upsert' &&
            tipo !== 'trip-status-analysis-delete'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}